'use client';

import { __assign } from '../../../_virtual/_tslib.js';

var setSingleTemporaryValue = function (state, action) {
    var formattedPayload = action.payload;
    var _a = formattedPayload.parentId, parentId = _a === void 0 ? -1 : _a, _b = formattedPayload.childrenId, childrenId = _b === void 0 ? -1 : _b;
    return __assign(__assign({}, state), { temporaryValue: [
            {
                parentId: parentId,
                childrenIds: [childrenId]
            }
        ] });
};

export { setSingleTemporaryValue };
//# sourceMappingURL=selectSingleReducer.js.map
